<div *ngIf="text" class="contentStyledText" [ngClass]="class" [innerHTML]="text"></div>
<!--TODO: Reemplazar en caso de implementar contenido mendiante transloco-->
<!--<div *ngIf="text" class="contentStyledText" [ngClass]="class" [innerHTML]="text.join('\n')"></div>-->

